export default "__VITE_ASSET__qFNlkODIo1nj_GRT4FJaRQ__"